"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PromoPanelState = /** @class */ (function () {
    function PromoPanelState() {
        this.isPanelError = false;
        this.panelErrMsg = '';
        this.isRepCodeAvailable = false;
        this.repcodeDetails = '';
        this.savingsPanelError = false;
        this.errMsg = '';
        this.showPromoCart = true;
        this.showMySaving = true;
    }
    return PromoPanelState;
}());
exports.default = PromoPanelState;
//# sourceMappingURL=PromoPanelState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/PromoPanelState.js
// module id = 2240
// module chunks = 8